
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { OrderListDto, purchaseOrderAgainAppApi } from '@/api/order'
import { purchaseGoodsAgain } from "@/api/shopOrder";
import { downloadUrl } from '@/utils/util'
import { Getter } from 'vuex-class'
import HandleFlowDialog from '@/views/orderManage/template/HandleFlowDialog.vue'
import moment from 'moment'
import { toNumber } from 'lodash'

@Component({
  name: 'OrderListItem',
  components: {
    HandleFlowDialog,
  }
})
export default class OrderListItem extends Vue {
  @Getter companyId!: string
  @Prop() orderList: OrderListDto
  @Prop() flag: string
  @Prop() showSelect: boolean
  @Prop() orderToggle: number
  downloadUrl = downloadUrl
  moment = moment
  currRouteId = ''
  orderId = ''
  $refs!: {
    handleFlowDialog: HandleFlowDialog
  }

  // 查看订单详情
  toDetail (orderInfo) {
    if (this.flag == 'purchase') {
      if(!this.$isAction("purchaseOrderDetail")){
        this.$toast('暂无此操作权限，请联系管理员')
        return false
      }
      this.$router.push({
        path: '/purchaseOrderDetail',
        query: {
          orderId: orderInfo.orderId,
          currRouteId: orderInfo.currRouteId
        }
      })
    } else {
      if(!this.$isAction("orderDetail")){
        this.$toast('暂无此操作权限，请联系管理员')
        return false
      }
      this.$router.push({
        path: '/orderDetail',
        query: {
          orderId: orderInfo.orderId,
          currRouteId: orderInfo.currRouteId
        }
      })
    }

  }

  // 查看日志
  // 分为退单和订单，订单isReturn 0 退单：isReturn 1
  toLog (orderInfo) {
    if(this.$route.path.includes('salesOrderList')){ //当为销售单页面 订货单
      // if(!this.$action(`toSaleLog`)){
      //   return false
      // }
    }
    if(this.$route.path.includes('purchaseOrderList')){ //当为采购单页面 订货单
      // if(!this.$action(`toLog`)){
      //   return false
      // }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='1'){ // 销售单搜索页面 订货单
      // if(!this.$isAction(`toSaleLog`)){
      //   this.$toast('暂无此操作权限，请联系管理员')
      //   return false
      // }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='2'){ // 采购单搜索页面 订货单
      // if(!this.$isAction(`toLog`)){
      //   this.$toast('暂无此操作权限，请联系管理员')
      //   return false
      // }
    }
    this.$router.push({
      path: '/log',
      query: {
        currRouteId: orderInfo.currRouteId,
        orderId: orderInfo.orderId,
        isReturn: '0'
      }
    })
  }

  /**
   * 再次购买
   */
  buyAgain(data) {
    if(this.$route.path.includes('searchOrder')){ //当为搜索销售单页面时权限控制
      // if(!this.$isAction('buyAgain')){
      //   this.$toast('暂无此操作权限，请联系管理员')
      //   return false
      // }
    }else{
      // if (!this.$action('buyAgain')) {
      //   return false
      // }
    }
    let params = {
      orderId: data.orderId,
      customerId: this.companyId,
      companyId: this.companyId,
      shopId: data.shopCompanyId,
      currRouteId: data.currRouteId
    }
      purchaseGoodsAgain(params).then(() => {
          this.$toast.success('已添加至购物车')
      }).catch(() => {})
  }

  /**
   * @description: 再来一单事件
   * @param {*}
   * @return {*}
   */
  toPlaceOrder (data: OrderListDto) {
    // if(!this.$isAction('add')){
    //   this.$toast('暂无此操作权限，请联系管理员')
    //   return false
    // }
    const obj = {
      companyId: this.companyId,
      orderId: data.orderId,
      currRouteId: data.currRouteId
    }
    purchaseOrderAgainAppApi(obj).then((res) => {
      if (res.code === '000000') {
        this.$router.push({
          path: '/valetOrder',
          query: {
            orderId: data.orderId,
            currRouteId: String(data.currRouteId),
            placeType: '2' // '2'为再来一单
          }
        })
      }
    })
  }

  /**
   * @description: 付款确认
   * @param {*操作类型：8：付款确认} operateType
   * @param {*操作对象} obj
   * @return {*}
   */
  handleCollection (operateType, obj) {
    // if(!this.$isAction('updateSaleOrderStatus4')){
    //   this.$toast('暂无此操作权限，请联系管理员')
    //   return false
    // }
    this.currRouteId = obj.currRouteId,
        this.orderId = obj.orderId
    let title
    let message
    let isRequired // 备注是否必填
    let isNumberInput // 确认收付款改为number输入框判断是否显示number输入框
    switch (operateType) {
      case 8:
        title = this.$route.path.includes('orderList') ? '确认收款' : '确认付款'
        message = this.$route.path.includes('orderList') ? '是否确认订单收款完成？' : '是否确认订单付款完成？'
        isRequired = false
        isNumberInput = true
        break
    }
    (this.$refs.handleFlowDialog as any).show({title, message, operateType, isRequired, isNumberInput})
  }

  handleFlowConfirm ({remark, operateType}) {
    // 成功提示
    let tips
    switch (operateType) {
      case 8:
        tips = this.$route.path.includes('salesOrderList') ? '确认收款完成' : '确认付款完成'
        break
    }
    // 处理获取请求参数
    let query = this.$route.query
    let params = {
      companyId: this.companyId,
      currRouteId: this.currRouteId,
      orderId: this.orderId,
      orderType: 1,
      money: toNumber(remark)
    }
    this.$emit('updateOrderStatus', params, tips, operateType)
  }

  /**
   * @description: 操作方法
   * @param {*操作类型：1：订单审核2：出库确认3：发货确认6：作废7：删除8：付款确认} operateType
   * @param {*操作对象} obj
   * @return {*}
   */
  handleOperation (operateType, obj) {
    if(this.$route.path.includes('salesOrderList')){ //当为销售单页面时权限控制
      if(!this.$action(`updateSaleOrderStatus${operateType}`)){
        return false
      }
    }
    if(this.$route.path.includes('purchaseOrderList')){ //当为采购单页面时权限控制
      if(!this.$action(`updateOrderStatus${operateType}`)){
        return false
      }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='1'){ //当为搜索销售单页面时权限控制
      if(!this.$isAction(`updateSaleOrderStatus${operateType}`)){
        this.$toast('暂无此操作权限，请联系管理员')
        return false
      }
    }
    if(this.$route.path.includes('searchOrder')&&this.$route.query.topType==='2'){ //当为搜索采购单页面时权限控制
      if(!this.$isAction(`updateOrderStatus${operateType}`)){
        this.$toast('暂无此操作权限，请联系管理员')
        return false
      }
    }
    let tips
    switch (operateType) {
      case 1:
        tips = '订单审核'
        break
      case 2:
        tips = '订单出库'
        break
      case 3:
        tips = '订单发货'
        break
      case 4:
        tips = '确认收货'
        break;
    }
    let orderIdList = [
      {
        currRouteId: obj.currRouteId,
        orderId: obj.orderId
      }
    ]
    let params = {
      companyId: this.companyId,
      operateType,
      orderIdList
    }

    this.$emit('updateOrderStatus', params, tips, operateType)
  }
}
